
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/projects/[scpca_id]",
      function () {
        return require("private-next-pages/projects/[scpca_id].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/projects/[scpca_id]"])
      });
    }
  